<template>
  <div>
    <list
      row-key="OrderId"
      ref="list"
      unit="售后订单"
      :page="page"
      :query-params="params"
      :show-checkbox="false"
      :show-query="showQuery"
      :get-data-func="api.orderList"
      @reset-query="$emit('reset-select')"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="订单编号">
          <el-input
            size="mini"
            v-model="params.OrderNo"
            placeholder="请输入订单编号"
            clearable
          />
        </el-form-item>
        <el-form-item label="用户昵称">
          <el-input
            size="mini"
            v-model="params.NiceName"
            placeholder="请输入用户昵称"
            clearable
          />
        </el-form-item>
        <el-form-item label="订单时间">
          <el-date-picker
            size="mini"
            v-model.trim="params.StartTime"
            placeholder="请选择日期"
            value-format="yyyy-MM-dd"
            style="width: 180px"
          ></el-date-picker>
          <span style="margin: 0 10px">-</span>
          <el-date-picker
            size="mini"
            v-model.trim="params.EndTime"
            placeholder="请选择日期"
            value-format="yyyy-MM-dd"
            style="width: 180px"
          ></el-date-picker>
        </el-form-item>
        <!-- <el-form-item label="订单状态">
          <el-select size="mini" v-model="params.Status" placeholder="请选择订单状态" clearable>
            <el-option label="未完成" :value="0"></el-option>
            <el-option label="已完成" :value="1"></el-option>
            <el-option label="已取消" :value="2"></el-option>
          </el-select>
        </el-form-item> -->
        <!-- <el-form-item label="发货状态">
          <el-select size="mini" v-model="params.SendState" placeholder="请选择发货状态" clearable>
            <el-option label="待发货" :value="1"></el-option>
            <el-option label="待收货" :value="2"></el-option>
            <el-option label="已完成" :value="3"></el-option>
          </el-select>
        </el-form-item> -->
        <!-- <el-form-item label="付款状态">
          <el-select size="mini" v-model="params.PayState" placeholder="请选择付款状态" clearable>
            <el-option label="退款中" :value="2"></el-option>
            <el-option label="已退款" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="退款状态">
          <el-select size="mini" v-model="params.RefundState" placeholder="请选择退款状态" clearable>
            <el-option label="退款待审" :value="1"></el-option>
            <el-option label="客户取消" :value="2"></el-option>
            <el-option label="同意退款" :value="3"></el-option>
            <el-option label="拒绝退款" :value="4"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="售后状态">
          <el-select
            size="mini"
            v-model="params.AfterSalesState"
            placeholder="请选择售后状态"
            clearable
          >
            <el-option label="待商家审核" :value="1"></el-option>
            <el-option label="商家审核通过" :value="2"></el-option>
            <el-option label="商家审核不通过" :value="3"></el-option>
            <el-option label="待买家退货" :value="4"></el-option>
            <el-option label="待商家收货" :value="5"></el-option>
            <el-option label="商家已退款" :value="6"></el-option>
          </el-select>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column label="序号" align="center" type="index" width="50">
        </el-table-column>
        <!-- <el-table-column
          prop="StoreName"
          label="所属商家"
          width="180px"
          v-if="loginInfo.UserType == 0"
        /> -->
        <el-table-column prop="OrderNo" label="订单信息" width="200px">
          <template slot-scope="{ row }">
            <span
              style="display: block; color: #409eff"
              v-clipboard:copy="row.OrderNo"
              v-clipboard:success="copySuccess"
              v-clipboard:error="copyError"
              >{{ row.OrderNo }}<i class="el-icon-copy-document"></i
            ></span>
            <span><i class="el-icon-time"></i>{{ row.OrderDate }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="GoodsName" label="商品信息" width="320px">
          <template slot-scope="{ row }">
            <el-table
              :data="row.OrderGoods"
              class="gtable"
              style="width: 100%"
              :show-header="false"
              :border="false"
              :row-style="rowStyle"
            >
              <el-table-column prop="GoodsCover" width="80px">
                <template slot-scope="{ row }">
                  <el-image ref="img" :src="'/api' + row.GoodsCover"
                /></template>
              </el-table-column>
              <el-table-column prop="GoodsName">
                <template slot-scope="{ row }">
                  <span style="display: block">{{ row.GoodsName }}</span>
                  <span style="display: block"
                    >规格：{{ row.AttributeName }}</span
                  >
                  <span
                    ><span style="color: red">{{
                      "¥" +  Number(row.PlatformPrice||0).toFixed(2)
                    }}</span
                    >{{ " x " + row.MainunitCount }}</span
                  >
                </template>
              </el-table-column>
            </el-table>
          </template>
        </el-table-column>
        <el-table-column prop="SubTotal" label="实付款" align="center">
          <template slot-scope="{ row }">
            <span style="display: block; text-align: center; color: red">{{
              "¥" +  Number(row.SubTotal||0).toFixed(2)
            }}</span>
            <span>（含运费：{{  Number(row.RealityExpressamount||0).toFixed(2) }}）</span>
          </template>
        </el-table-column>
        <el-table-column prop="ExpressModeText" label="配送方式">
        </el-table-column>
        <!-- <el-table-column prop="OrderDate" label="订单时间" width="160px" /> -->
        <!-- <template slot-scope="{row}">
            <span>{{$commonJs.toDateString(row.AddTime)}}</span>
          </template>
        </el-table-column> -->
        <el-table-column prop="ReceivingPerson" label="收货信息">
          <template slot-scope="{ row }">
            <span style="display: block">{{
              row.ReceivingPerson + " " + row.ReceivingPhone
            }}</span>
            <span>{{ row.ReceivingAddress }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="ReceivingPhone" label="联系电话" />
        <el-table-column prop="ReceivingAddress" label="收货地址" /> -->
        <el-table-column prop="PersonName" label="买家信息" align="center">
          <template slot-scope="{ row }">
            <span style="display: block; color: #409eff">{{
              row.NickName
            }}</span>
            <span>{{ row.ContactPhone }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="AfterSaleState"
          label="售后状态"
          align="center"
          width="120px"
        >
          <template slot-scope="{ row }">
            <span v-if="row.AfterSalesState == 1">待商家审核</span>
            <span v-if="row.AfterSalesState == 2">商家审核通过</span>
            <span v-if="row.AfterSalesState == 3">商家审核不通过</span>
            <span v-if="row.AfterSalesState == 4">待买家退货</span>
            <span v-if="row.AfterSalesState == 5">待商家收货</span>
            <span v-if="row.AfterSalesState == 6">商家已退款</span>
          </template>
        </el-table-column>
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require("@/api/sale/order/order").default,
      params: {
        OrderNo: "",
        OrderState: 5, //订单状态
        SendState: null, //发货状态
        PayState: null, //付款状态
        RefundState: null, //退款状态
      },
      loginInfo: JSON.parse(localStorage.getItem("loginInfo")),
    };
  },
  mounted() {
    if (this.$route.query.state == 1) {
      this.params.AfterSalesState = 1;
      this.query(this.params);
    }
  },
  methods: {
    copySuccess() {
      this.$message.success("复制成功");
    },
    copyError() {
      this.$message.error("复制失败");
    },
    rowStyle({ row, index }) {
      return "border:0";
    },
    getDataFunc(params) {
      return new Promise((resolve, reject) => {
        resolve({ Count: 0, Data: [{ RecordId: 1 }] });
      });
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>
<style lang="scss">
.gtable .el-table__cell {
  border: 0;
}
</style>